<template>
  <div class="footer">
    <img class="logo" src="img/seafire_footer_logo.svg" alt="">
    <div class="detail">
      <p class="copy">&copy; Seafire Ventures, LLC. All rights reserved</p>
      <p class="partners">Unilever, Mercedes-Benz, Bank of Montreal, Anheuser-Busch, and Verizon logos are trademarks or registered trademarks of their respective holders. </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'site-footer',
}
</script>

<style lang="scss" scoped>
  .footer {
    min-height: 335px;
    background: #111215;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    padding: 0 72px;
    font-size: 85%;
    .logo {
      margin-bottom: 56px;
    }
    .copy {
      color: #fff;
    }
    .partners {
      color: rgba(#fff, .6);
    }
  }
</style>